import Mousetrap from 'mousetrap'

angular
  .module('deskfy.arts')
  .controller('UserCollectionController', UserCollectionController)

const COLLECTION_CONTENT_TYPE = {
  TEMPLATES: 'templates',
  COLLECTIONS: 'collections'
}

/* @ngInject */
function UserCollectionController ($rootScope, $scope, $state, $timeout, $window, $translate, $stateParams, $q, SegmentService, ArtCollectionsService, ToastService, MessageService, AssetPreviewService, SelectMaterialCollectionService) {
  $scope.selectedTemplates = []
  $scope.selectedCollections = []
  $scope.breadcrumbs = {
    items: []
  }
  $scope.search = {
    filters: {},
    state: {
      searching: false
    }
  }

  $scope.collection = {
    state: {
      loading: true
    },
    result: {},
    templates: {
      state: {
        loading: false
      },
      results: [],
      pagination: {
        top: 8,
        skip: 0
      },
      totalCount: undefined
    },
    collections: {
      state: {
        loading: false
      },
      results: [],
      pagination: {
        top: 8,
        skip: 0
      },
      totalCount: undefined
    }
  }

  $scope.disabledTemplatesRule = null
  $scope.floatingBarLocation = 'userCollection'

  $scope.isLoadingContent = () => $scope.collection.state.loading || $scope.collection.collections.state.loading || $scope.collection.templates.state.loading
  $scope.getCollectionTotalCount = () => ($scope.collection.collections.totalCount ?? 0) + ($scope.collection.templates.totalCount ?? 0)
  $scope.getCollectionResultCount = () => ($scope.collection.collections.results?.length ?? 0) + ($scope.collection.templates.results?.length ?? 0)
  $scope.canShowFooter = () => $scope.isLoadingContent() || $scope.getCollectionResultCount() > 0

  const api = {
    _loadCollection,
    _loadBreadcrumbs,
    _loadCollectionValues,
    _getCollectionValues,
    _normalizeCollectionValues,
    _clearAllSelections,
    _handleOpenQuickPreview,
    _handleQuickPreview,
    _clearSelectedTemplate,
    _getSelectedTemplateSection,
    _loadMoreCollectionValues,
    _loadMoreTemplateValues,
    _handleKeyboardNavigation,
    _handleNavigateThroughKeyboard,
    _defineDisabledTemplatesRule
  }
  this.getApi = () => api

  activate()
  function activate () {
    if (!$stateParams.id) return $state.go('user.arts')
    api._loadCollection()
    api._handleQuickPreview()
    api._handleKeyboardNavigation()

    $timeout(() => {
      $window.scrollTo(0, 0)
      $scope.$parent.sidebar.selectedMenuId = null
    }, 100)
  }

  $scope.$on('$destroy', () => {
    Mousetrap.unbind('space')
    document.removeEventListener('click', api._clearSelectedTemplate)
    AssetPreviewService.closePreview()
    document.removeEventListener('keydown', api._handleNavigateThroughKeyboard)
  })

  function _clearAllSelections (templates) {
    if (templates && templates.length > 0) {
      templates.forEach(t => {
        if (t) {
          t.selected = false
        }
      })
    }
  }

  /**
   * Handle filters change of <user-search-bar> component and apply to request.
   */
  $scope.handleFilterChange = function (filters) {
    if (JSON.stringify($scope.search.filters) === JSON.stringify(filters)) return
    $scope.search.filters = filters
    $scope.search.state.searching = Object.keys(filters).length > 0
    $scope.collection = {
      ...$scope.collection,
      collections: {
        ...$scope.collection.collections,
        results: [],
        totalCount: undefined,
        pagination: {
          ...$scope.collection.collections.pagination,
          skip: 0
        }
      },
      templates: {
        ...$scope.collection.templates,
        results: [],
        totalCount: undefined,
        pagination: {
          ...$scope.collection.templates.pagination,
          skip: 0
        }
      }
    }
    api._loadCollectionValues()

    if ($scope.search.state.searching) {
      const getNormalizedTrackingValue = (value) => {
        if (!value) return
        if (Array.isArray(value)) return value.join(',')
        return value
      }
      SegmentService.track('arts-search-collection', {
        search_text: filters.query,
        is_highlight: $scope.collection.result.highlighted ?? false,
        search_level: getNormalizedTrackingValue(filters?.customizationLevel),
        search_format: getNormalizedTrackingValue(filters?.formatIds),
        search_approval: getNormalizedTrackingValue(filters?.needApproval),
        search_category: getNormalizedTrackingValue(filters?.tagIds)
      })
    }
  }

  $scope.handleLoadMoreContent = function () {
    api._loadCollectionValues()
  }

  $scope.onCollectionCardClick = (collection, event) => {
    const isShiftPressed = event && event.shiftKey

    if (collection.selected) {
      collection.firstSelection = false
      collection.selected = false
      $scope.selectedCollections = $scope.selectedCollections.filter(c => c.id !== collection.id)
    } else {
      if ($scope.selectedCollections.length === 0 && $scope.selectedTemplates.length === 0) {
        collection.firstSelection = true
      }

      if (isShiftPressed) {
        const { selectedCollections, selectedTemplates } = SelectMaterialCollectionService.handleShiftClickOnCollection(collection, {
          selectedTemplates: $scope.selectedTemplates,
          selectedCollections: $scope.selectedCollections,
          section: $scope.collection,
          disabledTemplatesRule: $scope.disabledTemplatesRule
        })

        $scope.selectedCollections = selectedCollections
        $scope.selectedTemplates = selectedTemplates
        return
      }

      collection.selected = true
      $scope.selectedCollections.push(collection)
    }
  }

  $scope.handleTemplateClick = function (template, event) {
    const isShiftPressed = event && event.shiftKey

    if (template.selected) {
      template.selected = false
      $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
    } else {
      if ($scope.selectedTemplates.length === 0) {
        template.firstSelection = true
      }

      if (isShiftPressed) {
        const { selectedCollections, selectedTemplates } = SelectMaterialCollectionService.handleShiftClickOnMaterial(template, {
          selectedTemplates: $scope.selectedTemplates,
          selectedCollections: $scope.selectedCollections,
          collection: $scope.collection,
          disabledTemplatesRule: $scope.disabledTemplatesRule
        })

        $scope.selectedCollections = selectedCollections
        $scope.selectedTemplates = selectedTemplates

        api._defineDisabledTemplatesRule()
        return
      }

      template.selected = true
      if (!$scope.selectedTemplates.some(t => t.id === template.id)) {
        $scope.selectedTemplates.push(template)
      }
    }

    api._defineDisabledTemplatesRule()
  }

  $scope.isTemplateDisabled = function (template) {
    if ($scope.disabledTemplatesRule === 'ALL' && $scope.selectedTemplates.length) {
      return template.id !== $scope.selectedTemplates[0].id
    } else if ($scope.disabledTemplatesRule === 'CUSTOMIZABLE') {
      return template.isCustomizable && template.customizationLevel !== 'ONLY_DOWNLOAD'
    }

    return false
  }

  $scope.unselectAllAssets = () => {
    $scope.selectedTemplates.forEach(template => {
      template.firstSelection = false
      template.selected = false
    })

    $scope.selectedCollections.forEach(collection => {
      collection.firstSelection = false
      collection.selected = false
    })

    $scope.selectedTemplates = []
    $scope.selectedCollections = []

    api._defineDisabledTemplatesRule()
  }

  function _loadBreadcrumbs () {
    const root = {
      id: 'user.arts',
      label: $translate.instant('userArts.arts.title'),
      value: 'user.arts'
    }

    ArtCollectionsService.getArtCollectionPath($stateParams.id)
      .then(response => {
        const normalizedItems = response?.map(collection => ({
          id: collection.id,
          value: collection.id,
          label: collection.title
        }))

        const [firstItem] = normalizedItems
        if (firstItem) {
          $timeout(() => {
            $scope.$parent.sidebar.selectedItemId = +firstItem.id
          }, 100)
        }

        $scope.breadcrumbs = {
          items: [root, ...(normalizedItems ?? [])],
          onChange: (event) => {
            if (typeof event.value !== 'number') return $state.go(event.value, {}, { reload: true })
            return $state.go('user.collection', { id: event.value }, { reload: 'user.collection' })
          }
        }
      })
  }

  function _handleKeyboardNavigation () {
    document.addEventListener('keydown', api._handleNavigateThroughKeyboard)
  }

  function _handleNavigateThroughKeyboard (ev) {
    const isAssetPreviewOpen = AssetPreviewService.assetPreviewIsOpen()

    if ((!$scope.selectedTemplates.length && !$scope.selectedCollections.length) || isAssetPreviewOpen) {
      return
    }

    SelectMaterialCollectionService.handleNavigateThroughKeyboard(ev, {
      selectedTemplates: $scope.selectedTemplates,
      selectedCollections: $scope.selectedCollections,
      collection: $scope.collection,
      scope: $scope,
      disabledTemplatesRule: $scope.disabledTemplatesRule
    })

    api._defineDisabledTemplatesRule()
  }

  function _loadCollection () {
    $scope.collection.state.loading = true
    ArtCollectionsService.find($stateParams.id)
      .then(collection => {
        if (!collection) {
          MessageService.error({
            title: $translate.instant('oopsTitle'),
            text: $translate.instant('collectionIsArchived'),
            confirmButtonText: $translate.instant('ok'),
            press: () => {
              $state.go('user.arts')
            }
          })

          return
        }

        $scope.collection.result = collection
        api._loadBreadcrumbs()
        api._loadCollectionValues()

        SegmentService.track('arts-colecao-pageview', {
          is_highlight: collection.highlighted,
          is_subcollection: collection?.parent && collection?.parent.length > 0
        })
      })
      .catch(error => {
        console.error({ error })
        ToastService.defaultErrorToast()
      })
      .finally(() => {
        $timeout(() => {
          $scope.collection.state.loading = false
        }, 100)
      })
  }

  function _loadMoreCollectionValues () {
    const collections = $scope.collection.collections
    collections.state.loading = true

    ArtCollectionsService.getCollectionsById($scope.collection.result.id, {
      top: collections.pagination.top,
      skip: collections.pagination.skip,
      search: $scope.search?.filters?.query
    })
      .then(response => {
        $scope.$applyAsync(() => {
          collections.results = [...collections.results, ...response.rows]
          collections.pagination.skip = collections.pagination.skip + response.rows.length
          collections.state.loading = false
        })
      })
  }

  function _loadMoreTemplateValues () {
    const templates = $scope.collection.templates
    templates.state.loading = true

    const searchParams = {
      search: $scope.search?.filters?.query,
      formatId: $scope.search?.filters?.formatIds,
      artTagIds: $scope.search?.filters?.tagIds,
      needApproval: $scope.search?.filters?.needApproval,
      customizationLevel: $scope.search?.filters?.customizationLevel,
      top: templates.pagination.top,
      skip: templates.pagination.skip
    }

    ArtCollectionsService.getTemplatesById($scope.collection.result.id, searchParams)
      .then(response => {
        $scope.$applyAsync(() => {
          templates.results = [...templates.results, ...response.rows]
          templates.pagination.skip = templates.pagination.skip + response.rows.length
          templates.state.loading = false
        })
      })
  }

  $scope.handleLoadMoreCollectionValues = function () {
    api._loadMoreCollectionValues()
  }

  $scope.handleLoadMoreTemplateValues = function () {
    api._loadMoreTemplateValues()
  }

  function _loadCollectionValues () {
    $scope.collection.templates.state.loading = true
    $scope.collection.collections.state.loading = true

    const searchParams = {
      search: $scope.search?.filters?.query,
      formatId: $scope.search?.filters?.formatIds,
      artTagIds: $scope.search?.filters?.tagIds,
      needApproval: $scope.search?.filters?.needApproval,
      customizationLevel: $scope.search?.filters?.customizationLevel
    }

    $q
      .all([
        api._getCollectionValues({ type: COLLECTION_CONTENT_TYPE.TEMPLATES, callback: ArtCollectionsService.getTemplatesById, params: searchParams }),
        api._getCollectionValues({ type: COLLECTION_CONTENT_TYPE.COLLECTIONS, callback: ArtCollectionsService.getCollectionsById, params: searchParams })
      ])
      .then(([templates, collections]) => {
        $scope.$applyAsync(() => {
          api._normalizeCollectionValues({ templates, collections })
        })
      })
      .catch(error => {
        console.error({ error })
        if (error?.status === 400 && error?.data?.code === 'CANNOT_ACCESS_COLLECTION') {
          ToastService.showErrorToast($translate.instant('collectionExpired'))
        } else {
          ToastService.defaultErrorToast()
        }
      })
      .finally(() => {
        $scope.collection.templates.state.loading = false
        $scope.collection.collections.state.loading = false
      })
  }

  /**
   * Request collection values from API.
   *
   * @param {Object} params
   * @param {Function} params.callback Callback to request data from API.
   * @param {String} params.type Collection type, use COLLECTION_CONTENT_TYPE.
   */
  function _getCollectionValues ({ type, callback, params = {} }) {
    const collection = $scope.collection
    if (!collection?.result.id || !type || !callback) return

    const skip = collection[type]?.pagination.skip ?? 0
    const totalCount = collection[type]?.totalCount ?? 0
    if (skip > totalCount) return []

    return callback?.(collection.result.id, { top: collection[type].pagination.top, skip, ...(params) })
  }

  /**
   * Normalize collection templates and collections.
   *
   * @param {Object} params
   * @param {Object} params.templates Templates.
   * @param {Object} params.collections Collections.
   */
  function _normalizeCollectionValues ({ templates, collections }) {
    const collection = $scope.collection
    $scope.collection = {
      ...collection,
      templates: {
        ...(collection?.templates ?? {}),
        results: [...(collection?.templates?.results ?? []), ...(templates?.rows ?? [])],
        pagination: {
          ...collection?.templates.pagination,
          skip: (collection?.templates?.pagination.skip ?? 0) + (templates?.rows?.length ?? 0)
        },
        totalCount: collection.templates?.totalCount ?? templates.count ?? 0
      },
      collections: {
        ...(collection?.collections ?? {}),
        results: [...(collection?.collections?.results ?? []), ...(collections?.rows ?? [])],
        pagination: {
          ...collection?.collections.pagination,
          skip: (collection?.collections?.pagination.skip ?? 0) + (collections?.rows?.length ?? 0)
        },
        totalCount: collection.collections?.totalCount ?? collections.count ?? 0
      }
    }
  }

  function _handleQuickPreview () {
    Mousetrap.bind('space', api._handleOpenQuickPreview)
    document.addEventListener('click', api._clearSelectedTemplate)
  }

  function _clearSelectedTemplate (ev) {
    const isTemplateCard = ev.target.closest('template-item')

    if (!isTemplateCard && !AssetPreviewService.assetPreviewIsOpen()) {
      $timeout(() => {
        if ($scope.selectedTemplates && $scope.selectedTemplates.length > 0) {
          api._clearAllSelections($scope.selectedTemplates)
          $scope.selectedTemplates = []
        }
      })
    }
  }

  $scope.handleOpenQuickPreview = (event) => api._handleOpenQuickPreview(event)

  function _handleOpenQuickPreview (ev) {
    const isSpaceBar = ev.code !== 'Space' && ev.keyCode !== 32
    if (isSpaceBar || ev.repeat || !$scope.selectedTemplates || $scope.selectedTemplates.length === 0) {
      return
    }

    if (!AssetPreviewService.assetPreviewIsOpen() && AssetPreviewService.assetQuickPreviewIsOpen()) {
      ev.preventDefault()
      AssetPreviewService.closePreview()
      return
    }

    if (!AssetPreviewService.assetPreviewIsOpen() && !AssetPreviewService.assetQuickPreviewIsOpen()) {
      ev.preventDefault()
      AssetPreviewService.openAssetQuickPreview({
        currentAsset: $scope.selectedTemplates[0],
        assets: $scope.search.templates?.length ? $scope.search.templates : api._getSelectedTemplateSection($scope.selectedTemplates[0])
      })
    }
  }

  function _getSelectedTemplateSection (template) {
    if (!template) return []

    return $scope.collection.templates.results || []
  }

  $scope.isPreviewEnabled = () => AssetPreviewService.isPreviewEnabled()

  $scope.getPreviewAssets = () => {
    const deferred = $q.defer()

    deferred.resolve({
      assets: $scope.collection.templates.results || [],
      count: $scope.collection.templates.totalCount
    })

    return deferred.promise
  }

  function _defineDisabledTemplatesRule () {
    $scope.disabledTemplatesRule = SelectMaterialCollectionService.getDisabledTemplatesRule($scope.selectedTemplates)
    if (!$scope.$$phase) {
      $scope.$apply()
    }
  }
}

export { UserCollectionController }
